import { dramaPatterns } from "@/mocks/siteContent";

export default function DramaSection() {
  return (
    <section id="drama" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-4">
            <i className="ri-film-line" aria-hidden="true"></i>
            短剧版本盘点
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            同一母题的四条常见走向，看点各不一样
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            短剧受时长限制，通常会在开局几集内抛出强冲突，再用高密度反转留住观众。以下是这类题材最常见的四条叙事走向，横向对比后，你会更容易找到对味的那一条。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {dramaPatterns.map((item) => (
            <article
              key={item.tag}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden flex flex-col transition-colors hover:border-primary-300"
            >
              <div className="w-full h-44 md:h-48 overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`${item.tag} 剧情走向示意图`}
                  title={`${item.tag} 邻居的妻子短剧剧情走向`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">{item.tag}</h3>
                <div className="mt-3 flex flex-wrap gap-2">
                  {item.keywords.map((kw) => (
                    <span
                      key={kw}
                      className="px-2.5 py-1 rounded-full text-xs bg-secondary-100 text-secondary-900"
                    >
                      {kw}
                    </span>
                  ))}
                </div>
                <p className="mt-4 text-sm text-foreground-700 leading-relaxed flex-1">{item.plot}</p>
                <div className="mt-4 pt-4 border-t border-background-200/70 flex items-start gap-2">
                  <i className="ri-lightbulb-flash-line text-accent-600 mt-0.5 shrink-0" aria-hidden="true"></i>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.highlight}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}